import { render } from "./musteriCard.vue?vue&type=template&id=052bc3d8&scoped=true"
import script from "./musteriCard.vue?vue&type=script&lang=js"
export * from "./musteriCard.vue?vue&type=script&lang=js"

import "./musteriCard.vue?vue&type=style&index=0&id=052bc3d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052bc3d8"]])

export default __exports__